import request from '@/utils/request'

export function GetHomeBanner() {
    return request({
        url: '/banner/home',
        method: 'get',
    })
}

export function GetProductBanner() {
    return request({
        url: '/banner/product',
        method: 'get',
    })
}